// if (!customElements.get('section-tabs')) {
//   customElements.define('section-tabs', class SectionTabs extends HTMLElement {
//       constructor() {
//         super();
//         this.crazySelector = ".section-section-tabs:has([data-num-sections]) + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='2']) + .shopify-section + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='3']) + .shopify-section + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='3']) + .shopify-section + .shopify-section + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section + .shopify-section,\n" +
//           ".section-section-tabs:has([data-num-sections='4']) + .shopify-section + .shopify-section + .shopify-section + .shopify-section";

//         if (Shopify.designMode) {
//           this.checkboxes = this.querySelectorAll('.field__checkbox');
//           this.section = this.closest('.shopify-section');

//           if (this.checkboxes) {
//             document.addEventListener('shopify:section:select', this.updateTabSelection.bind(this));
//             document.addEventListener('shopify:section:reorder', this.updateTabSelection.bind(this));
//           }
//         } else {
//           setTimeout(() => {
//             document.querySelectorAll(this.crazySelector).forEach((section, index) => {
//               const ariaElem = this.querySelector(`div[role='tab']:has(input[value="${index + 1}"])`);
//               const checkbox = this.querySelector(`input[value="${index + 1}"]`);
//               if (checkbox) {
//                 ariaElem?.setAttribute('aria-controls', section.id);
//                 if (checkbox.checked) this.setSelectedTab(checkbox, section);
//                 checkbox.addEventListener('change', () => { this.setSelectedTab(checkbox, section); });
//               }

//               // Add role="tabpanel" to the section
//               section.setAttribute('role', 'tabpanel');

//               // Disable scroll animations
//               section.querySelectorAll('.scroll-trigger--offscreen').forEach(elem => {
//                 elem.classList.remove('scroll-trigger--offscreen');
//               });
//             });
//           }, 100);

//           setTimeout(() => {
//             document.querySelectorAll(this.crazySelector).forEach(section => {
//               // Preload lazy images
//               section.querySelectorAll('img[loading="lazy"]').forEach(img => {
//                 img.loading = 'eager';
//               });
//             });
//           }, 6000);
//         }
//       }

//       updateTabSelection(event) {
//         if (event.target.matches(this.crazySelector)) {
//           // Find how many sections the matched one is from the current section
//           let currentElement = this.section;
//           let count = 0;
//           while (currentElement && currentElement !== event.target) {
//             currentElement = currentElement.nextElementSibling;
//             count++;
//           }

//           this.checkboxes[count - 1].checked = true;
//         }
//       }

//       setSelectedTab(checkbox, associatedPanel) {
//         // Deselect all tabs and hide all panels
//         this.querySelectorAll('[role="tab"]').forEach(tab => {
//           tab.setAttribute('aria-selected', 'false');

//           const section = document.getElementById(tab.getAttribute('aria-controls'));
//           if (section) section.setAttribute('aria-hidden', 'true');
//         });

//         // Select the clicked tab and show the associated panel
//         checkbox.closest("div[role='tab']")?.setAttribute('aria-selected', 'true');
//         associatedPanel.setAttribute('aria-hidden', 'false');
//       }
//     }
//   );
// }


if (!customElements.get('section-tabs')) {
  customElements.define('section-tabs', class SectionTabs extends HTMLElement {
    constructor() {
      super();

      // 绑定延迟执行，确保 DOM 的 section 顺序稳定
      setTimeout(() => this.init(), 100);

      // 你原来的“6秒后 eager 图片”逻辑也放进 init 之后再跑
      setTimeout(() => this.preloadLazyImages(), 6000);
    }

    getNumSections() {
      return parseInt(this.closest('[data-num-sections]')?.dataset?.numSections || '0', 10);
    }

    getWrapperSection() {
      // 当前这个自定义元素所在的 Shopify section 外层
      return this.closest('.shopify-section');
    }

    getFollowingPanels(num) {
      const wrapper = this.getWrapperSection();
      if (!wrapper || !num) return [];

      const panels = [];
      let node = wrapper.nextElementSibling;

      while (node && panels.length < num) {
        if (node.classList && node.classList.contains('shopify-section')) {
          panels.push(node);
        }
        node = node.nextElementSibling;
      }
      return panels;
    }

    init() {
      const num = this.getNumSections();
      if (!num) return;

      const panels = this.getFollowingPanels(num);
      if (!panels.length) return;

      const radios = Array.from(this.querySelectorAll('input.field__checkbox[type="radio"]'));
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const count = Math.min(radios.length, panels.length, tabs.length);

      const activate = (activeIndex) => {
        // tabs
        tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));

        // panels：用 hidden 真隐藏
        panels.forEach((panel, i) => {
          const isActive = i === activeIndex;
          panel.hidden = !isActive;
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      // 初始化：给每个 panel 做 aria-controls + role，并绑定 change
      for (let i = 0; i < count; i++) {
        const panel = panels[i];
        const radio = radios[i];
        const tab = tabs[i];

        // aria-controls
        if (panel.id) tab.setAttribute('aria-controls', panel.id);

        // role=tabpanel
        panel.setAttribute('role', 'tabpanel');

        // disable scroll animations (保留你原逻辑)
        panel.querySelectorAll('.scroll-trigger--offscreen').forEach(elem => {
          elem.classList.remove('scroll-trigger--offscreen');
        });

        radio.addEventListener('change', () => {
          if (radio.checked) activate(i);
        });
      }

      // 初始选中
      const checkedIndex = radios.slice(0, count).findIndex(r => r.checked);
      activate(checkedIndex >= 0 ? checkedIndex : 0);

      // 让主题编辑器里点击某个“被 tab 化的 section”时，自动切到对应 tab
      if (Shopify.designMode) {
        this.wrapperSection = this.getWrapperSection();
        this.radios = radios;

        document.addEventListener('shopify:section:select', (event) => {
          const target = event?.target;
          if (!target || !target.classList?.contains('shopify-section')) return;

          // 只处理属于本 tabs 组的 panels
          const idx = panels.indexOf(target);
          if (idx >= 0 && this.radios[idx]) {
            this.radios[idx].checked = true;
            activate(idx);
          }
        });

        document.addEventListener('shopify:section:reorder', () => {
          // reorder 后重新初始化一次（最稳）
          this.init();
        });
      }
    }

    preloadLazyImages() {
      const num = this.getNumSections();
      const panels = this.getFollowingPanels(num);
      panels.forEach(panel => {
        panel.querySelectorAll('img[loading="lazy"]').forEach(img => {
          img.loading = 'eager';
        });
      });
    }
  });
}
